import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// NEW: роутер
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LawPage from './LawPage'; // NEW

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/law" element={<LawPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
